<script setup lang="ts">
import type { QuizType } from '@ts-types/quiz/types'
// helpers
import { getDataQA } from '@helpers/data-qa'

defineOptions({
  name: 'BtnSubmit'
})

interface BtnSubmitProps {
  text?: string;
  disabled?: boolean;
  selected?: boolean;
  quizType?: QuizType;
}

withDefaults(defineProps<BtnSubmitProps>(), {
  text: 'Continue',
  disabled: false,
  selected: false,
  quizType: 'default'
})

const emit = defineEmits<{
  click: [];
}>()

const handleClick = (): void => {
  emit('click')
}
</script>

<template>
  <button
    :class="['btn-submit', { selected }]"
    :data-qa="getDataQA(quizType, `quiz-button-continue`)"
    type="button"
    :disabled="disabled"
    @click="handleClick"
  >
    <span>{{ text }}</span>
    <span
      v-if="$slots.icon"
      class="btn-submit__icon"
    >
      <slot name="icon" />
    </span>
  </button>
</template>

<style scoped lang="scss" src="@scss/components/UI/Buttons/BtnSubmit.scss" />
